import {DrawerProps} from '@mantine/core';
import {useParams} from 'react-router-dom';
import {FormDrawer} from './FormDrawer.tsx';
import {usePersona} from '../hooks/usePersona.ts';
import {buildInitialValues} from '../forms/buildInitialValues.ts';

export const EditFormDrawer = (props: DrawerProps) => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const {
        record,
        updateRecord,
    } = usePersona(id);

    if (!record) return null;

    return (
        <FormDrawer
            record={buildInitialValues(record)}
            handleSubmit={updateRecord}
            {...props}
        />
    );
};
